import { environment } from '../../../environments/environment';

/**
 * The emulator port this build talks to: the standard `base` plus the environment's stack offset
 * (OE-216 — only the local-emulator build sets one, from the port it is served on).
 */
export function emulatorPort(base: number): number {
    return base + ((environment as { emulatorPortOffset?: number }).emulatorPortOffset ?? 0);
}
